import type { DefaultOptionType } from "antd/es/select";

/**
 * Case-insensitive substring matchers for a searchable antd `<Select>`.
 *
 * antd calls `filterOption(input, option)` for every option as the user types.
 * Assign one of these directly to the `filterOption` prop instead of inlining
 * the same `.toLowerCase().includes(...)` check at each call site.
 */
const includesCaseInsensitive = (haystack: unknown, needle: string): boolean =>
  (typeof haystack === "string" ? haystack : "").toLowerCase().includes(needle);

/** Matches the input against the option's `label` only. */
export const filterByLabel = (input: string, option?: DefaultOptionType): boolean =>
  includesCaseInsensitive(option?.label, input.toLowerCase());

/** Matches the input against the option's `label` or its `value`. */
export const filterByLabelOrValue = (
  input: string,
  option?: DefaultOptionType,
): boolean => {
  const needle = input.toLowerCase();
  return (
    includesCaseInsensitive(option?.label, needle) ||
    includesCaseInsensitive(option?.value, needle)
  );
};
